module.exports = __webpack_public_path__ + "img/disney_movies.4e168d73.jpg";